import {
    AcademicCapIcon,
    BriefcaseIcon,
    CurrencyEuroIcon,
    PencilIcon,
    PrinterIcon,
    SwitchHorizontalIcon,
} from '@heroicons/vue/solid'
import { i18n } from '../../../../localization'
import { ComputedRef, ConcreteComponent, RenderFunction } from 'vue'
import {
    EsacComplianceProfile,
    usePersonalAccountDataState,
} from '../../../../utilities/account/useAccountDataPersonal'
import ExperienceAndKnowledgeForm from '../../../wizard/ESAC/form/ExperienceAndKnowledgeForm.vue'
import FatcaDeclarationForm from '../../../wizard/ESAC/form/FatcaDeclarationForm.vue'
import FinancialConditionsForm from '../../../wizard/ESAC/form/FinancialConditionsForm.vue'
import InvestmentTargetsForm from '../../../wizard/ESAC/form/InvestmentTargetsForm.vue'
import RiskToleranceForm from '../../../wizard/ESAC/form/RiskToleranceForm.vue'
import AcknowledgementsForm from '../../../wizard/ESAC/form/AcknowledgementsForm.vue'
import TaxSituationForm from '../../../wizard/ESAC/form/TaxSituationForm.vue'

export const esacPersonalComplianceProfileConfig: EsacPersonalComplianceProfileConfig = {
    'Investment Targets': {
        component: InvestmentTargetsForm,
        icon: CurrencyEuroIcon,
        title: i18n.global.t('account_settings.investment_targets'),
        validationKey: 'investment_targets',
    },
    'Risk Tolerance': {
        component: RiskToleranceForm,
        icon: SwitchHorizontalIcon,
        title: i18n.global.t('account_settings.risk_tolerance'),
        validationKey: 'risk_tolerance',
    },
    'Financial Conditions': {
        component: FinancialConditionsForm,
        icon: BriefcaseIcon,
        title: i18n.global.t('account_settings.financial_conditions'),
        validationKey: 'financial_conditions',
    },
    'Experience and Knowledge': {
        component: ExperienceAndKnowledgeForm,
        icon: AcademicCapIcon,
        title: i18n.global.t('account_settings.experience_and_knowledge'),
        validationKey: 'experience_and_knowledge',
    },
    'Acknowledgements': {
        component: AcknowledgementsForm,
        icon: PencilIcon,
        title: i18n.global.t('account_settings.acknowledgements'),
        validationKey: 'acknowledgements',
    },
    'Fatca Declaration': {
        component: FatcaDeclarationForm,
        icon: PrinterIcon,
        title: i18n.global.t('account_settings.fatca_declaration'),
        validationKey: 'fatca_declaration',
    },
    'Tax Situation': {
        component: TaxSituationForm,
        icon: PrinterIcon,
        title: i18n.global.t('account_settings.tax_situation'),
        validationKey: 'tax_situation',
    },
}

export interface EsacPersonalComplianceProfileConfig {
    [key: string]: {
        component: ConcreteComponent
        icon: RenderFunction | ConcreteComponent
        title: string
        buttonTitle?: string
        validationKey: keyof EsacComplianceProfile
        showsWarning?: ComputedRef<boolean>
        hideStatus?: boolean
        clearValuesOnClose?: boolean
        requireConfirm?: boolean
    }
}

export function isEsacPersonalComplianceProfileLocked() {
    return usePersonalAccountDataState().naturalProfile.is_locked === true
}
